export const MIN_POINTS_FOR_DISABLED_CLUSTER = 999999999; // What a hack :)
export const DEFAULT_ZOOM = 7;
